export const ADD_DS_CSLINE = 'ADD_DS_CSLINE';
export const CHANGE_DS_CSLINE = 'CHANGE_DS_CSLINE';
export const DEL_DS_CSLINE = 'DEL_DS_CSLINE';
export const DEL_ALLDS_CSLINE = 'DEL_ALLDS_CSLINE';
export const CHANGE_SELROW_CSLINE = 'CHANGE_SELROW_CSLINE';
export const CHANGE_NAME_CSLINE = 'CHANGE_NAME_CSLINE';
export const ISDEL_CSLINE = 'ISDEL_CSLINE';

export function addDsAction(data) {
    return {
        type: ADD_DS_CSLINE,
        data: data
    };
}

export function changeDsAction(data) {
    return {
        type: CHANGE_DS_CSLINE,
        data: data
    };
}

export function delDsAction(rowID) {
    return {
        type: DEL_DS_CSLINE,
        rowID: rowID
    };
}

export function delAllDsAction() {
    return {
        type: DEL_ALLDS_CSLINE
    };
}

export function changeSelRowAction(rowID) {
    return {
        type: CHANGE_SELROW_CSLINE,
        rowID: rowID
    };
}

export function changeNameAction(value) {
    return {
        type: CHANGE_NAME_CSLINE,
        value: value
    };
}

export function isDelAction(isDel) {
    return {
        type: ISDEL_CSLINE,
        isDel: isDel
    };
}
